import * as React from 'react';

import { Routes, Route, BrowserRouter } from 'react-router';

import Result from 'pages/Result';
import Scanner from 'pages/Scanner';
import GenerateQR from 'pages/GenerateQR';

import './App.css';

class App extends React.Component {
	render() {
		return (
			<section className="app">
				<BrowserRouter>
					<Routes>
						<Route path="/" element={<Scanner />} />
						<Route path="/scanner" element={<Scanner />} />
						<Route path="/correct" element={<Result message="Correct!" />} />
						<Route path="/incorrect" element={<Result message="Incorrect!" />} />
						<Route path="/generateqr" element={<GenerateQR />} />
					</Routes>
				</BrowserRouter>
			</section>
		);
	}
}

export default App;
